import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { OnboardingCompanyProgress } from 'constants/OnboardingCompanyProgress';
import { OnboardingContactStepResponse } from 'constants/OnboardingEnums';
import {
  OnboardingData,
  OnboardingFlowAccountStepFields,
  OnboardingFlowAddressStepFields,
  OnboardingFlowCompanyStepFields,
  OnboardingFlowContactStepFields,
} from 'modules/onboarding/types';

export const getOnboardingCompanyDataRequest = async (companyId: number): Promise<OnboardingData> => {
  const response = await getApi().get(`/OnboardingCompany/${companyId}`);
  return response.data;
};

export const postOnboardingCompanyStepRequest = async (
  data: OnboardingFlowCompanyStepFields,
  companyIdNumber: number,
): Promise<void> => {
  await getApi().post(`/OnboardingCompany/Company/${companyIdNumber}`, data);
};

export const postOnboardingAddressStepRequest = async (
  data: OnboardingFlowAddressStepFields,
  companyIdNumber: number,
): Promise<void> => {
  await getApi().post(`/OnboardingCompany/Address/${companyIdNumber}`, data);
};

export const postOnboardingContactStepRequest = async (
  data: OnboardingFlowContactStepFields,
  companyIdNumber: number,
): Promise<OnboardingContactStepResponse> => {
  const response = await getApi().post(`/OnboardingCompany/Contact/${companyIdNumber}`, data);
  return response.data;
};

export const postOnboardingAccountStepRequest = async (
  data: OnboardingFlowAccountStepFields,
  companyIdNumber: number,
): Promise<number> => {
  const response = await getApi().post(`/OnboardingCompany/Account/${companyIdNumber}`, data);
  return response.data;
};

export const agreeAndConfirmCollaborationRequest = async (companyId: number): Promise<number> => {
  const response = await getApi().post(`/OnboardingCompany/AgreeAndConfirm/${companyId}`);
  return response.data;
};

export const getOnboardingProgressRequest = async (companyId: number): Promise<OnboardingCompanyProgress> => {
  const response = await getApi().get(`/OnboardingCompany/Progress/${companyId}`);
  return response.data;
};
